// import React, { useState } from "react";
import {
    NavLink,
    useLoaderData,
    useNavigate,
} from "react-router-dom";
import {getProject, getProjectList} from '../../services/project.service';
//import DataTable from "react-data-table-component";
//import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from 'cdbreact';
//import { AgGridReact } from 'ag-grid-react';
//import "ag-grid-community/styles/ag-grid.css";
//import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme

import BaseListControl from '../../components/BaseListControl'
import CardControl, { CardHeaderControl, CardBodyControl } from "../../components/CardControl";
import ToolbarControl from "../../components/ToolbarControl";
import {PlusCircle, Search} from 'react-bootstrap-icons';
import {getPartList} from "../../services/part.service";
import BooleanControl from "../../components/BooleanControl";
import React, {useEffect, useState} from "react";
import {serializeQueryString} from "../../helpers/url.helper";
import CustomerControl from "../../components/CustomerControl";
import {getCustomer} from "../../services/customer.service";

/**
 * Renders information about the user obtained from TorinAPI
 * @param props 
 */
//export const ProjectListControl = (props) => {
//    console.log({ props: props });
//    return (
//        <div id="profile-div">
//            <table>
//                <thead>
//                    <tr>
//                        <th>Nummer</th>
//                        <th>Namn</th>
//                    </tr>
//                </thead>
//                <tbody>
//                {props ? props.list.map(item => (
//                    <tr key={ item.id }>
//                            <td>{item.number}</td>
//                            <td>{item.name}</td>
//                        </tr>
//                )) : null}
//                </tbody>
//            </table>
//        </div>
//    );
//};


const columns = [
    {
        headerName: "Nummer",
        field: "number",
        filter: true,
        // sort: "disable",
    },
    {
        headerName: "Namn",
        field: "name",
        width: 288,
        filter: true,
    },
    {
        headerName: "Kundnr",
        field: "customerNumber",
        filter: true,
    },
    {
        headerName: "Kund",
        field: "customerName",
        width: 400,
        filter: true,
    },
    {
        headerName: "Fakturaformat",
        field: "formatName",
        filter: true,
    },
]
let navigate;

//const data = (projectList) => {

//    return {
//        columns: columns,
//        rows: projectList
//    }
//}


export default function ProjectIndex() {
    // const { projectList, setProjectList } = useState(null);
    const { projectList, loaderFilter, customer } = useLoaderData();
    const [filter, setFilter] = useState(loaderFilter);
    navigate = useNavigate();
    // console.log({ instance: instance, accounts: accounts });

    const search = () => {
        navigate("?" + serializeQueryString({
            customerId: filter.customerId,
        }));
    };

    useEffect(() => {
        search();
    }, [filter]);

    return (
        <CardControl className="border-0">
            <CardHeaderControl>
                <ToolbarControl>
                    <div className="btn-group" role="group">
                        <button className="btn" onClick={() => {
                            navigate("create");
                        }}
                        >
                            <PlusCircle /> Skapa
                        </button>
                        <button className="btn" onClick={() => {
                            search();
                        }}
                        >
                            <Search /> Sök
                        </button>
                    </div>
                </ToolbarControl>
            </CardHeaderControl>
            <CardBodyControl>
                <div className="row">
                    <div className="col mb-3">
                        <CardControl className="border-1">
                            <CardBodyControl>
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-3 col-xl-2">
                                        <CustomerControl value={filter.customerId} onChange={(customerId) => {
                                            setFilter({ ...filter, customerId });
                                        }} allowEmpty />
                                    </div>
                                </div>
                            </CardBodyControl>
                        </CardControl>
                    </div>
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            {customer ? (
                              <NavLink title="Kund" to={"../../customer/" + filter.customerId}>{customer.name}</NavLink>
                            ) : (
                              <NavLink title="Kund" to={"../../customer/"}>&lrm;</NavLink>
                              //Osynlig bokstav för att inte ändra på storleken på fönstret
                            )}
                        </li>
                    </ol>
                </nav>
                <BaseListControl columns={columns} list={projectList} onRowClicked={rowClicked} tableName="Projekt" />
            </CardBodyControl>
        </CardControl>

        //<div className="ag-theme-quartz" style={{ height: 500 }}>
        //    <AgGridReact rowData={projectList} columnDefs={columns} />
        //</div>
        //<CDBContainer>
        //    <CDBCard>
        //        <CDBCardBody>
        //            <CDBDataTable
        //                striped
        //                bordered
        //                hover
        //                entriesOptions={[5, 20, 25]}
        //                entries={5}
        //                pagesAmount={4}
        //                data={data(projectList)}
        //                materialSearch={true}
        //            />
        //        </CDBCardBody>
        //    </CDBCard>
        //</CDBContainer>

        //    <div id="profile-div">
        //        <table>
        //            <thead>
        //                <tr>
        //                    <th>Nummer</th>
        //                    <th>Namn</th>
        //                </tr>
        //            </thead>
        //            <tbody>
        //                {projectList ? projectList.map(item => (
        //                    <tr key={item.id}>
        //                        <td>{item.number}</td>
        //                        <td>{item.name}</td>
        //                    </tr>
        //                )) : null}
        //            </tbody>
        //        </table>
        //    </div>
    );
}

function rowClicked(e) {
    const id = e.data.id;
    navigate("/project/" + id);
}

export async function loader({ msalInstance, request, params }) {

    //console.log({ msalInstance: msalInstance, request: request, params: params });

    let filter = {
        orderBy: [{ field: "customerName" }, { field: "name" }],
        customerId: new URL(request.request.url).searchParams.get('customerId'),
    }
    const projectList = await getProjectList(msalInstance, filter);
    let customer;
    if(filter.customerId) {
        customer = await getCustomer(msalInstance, filter.customerId);
    }

    return { projectList, loaderFilter: filter, customer };
}
